import { CardPaymentsComponentsAgreement } from './agreement'

export const CardPaymentsComponents = {
  Agreement: CardPaymentsComponentsAgreement,
}
